import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import HashtagForm, {
	HashtagFormValues
} from "../../components/HashtagForm/HashtagForm";
import useCreateAdminHashtag from "../../hooks/useCreateAdminHashtag";
import { adaptCreateHashtagPayload } from "../../adapters/adaptHashtagPayload";
import { formValuesToHashtag } from "../../adapters/formValuesToHashtag";

const EMPTY_DEFAULTS: HashtagFormValues = {
	name: "",
	description: "",
	color: "#2563eb",
	isPrivate: false,
	isFavourite: false,
	excludeFromMainFeed: false,
	image: null
};

const CreateHashtag = () => {
	const navigate = useNavigate();
	const { mutate: createHashtag, isLoading } = useCreateAdminHashtag();

	const handleSubmit = (data: HashtagFormValues) => {
		const payload = adaptCreateHashtagPayload(
			formValuesToHashtag(data),
			data.image
		);

		createHashtag(payload, {
			onSuccess: () => navigate("/social-feed/hashtags")
		});
	};

	return (
		<Page>
			<HashtagForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
			/>
		</Page>
	);
};

export default CreateHashtag;
